import { forwardRef, type SVGProps } from 'react';

export const Chevron = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ref={ref} {...props}>
    <g fill="currentColor">
      <path
        d="M.249 7.207l10.984 12.471a1.066 1.066 0 0 0 1.539 0L23.751 7.207a.987.987 0 0 0-.107-1.414l-1.85-1.557a1.028 1.028 0 0 0-1.438.111L12.191 13.8a.25.25 0 0 1-.379 0L3.644 4.346A1.021 1.021 0 0 0 2.948 4a1 1 0 0 0-.741.238L.356 5.793A.988.988 0 0 0 0 6.478a.978.978 0 0 0 .249.729z"
        fill="currentColor"
      />
    </g>
  </svg>
));

export const DoubleChevron = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ref={ref} {...props}>
    <g fill="currentColor">
      <path d="M13.584 12a2.643 2.643 0 01-.775 1.875l-9.541 9.541a1.768 1.768 0 01-2.5-2.5l8.739-8.739a.25.25 0 000-.354L.768 3.084a1.768 1.768 0 012.5-2.5l9.541 9.541A2.643 2.643 0 0113.584 12z" />
      <path d="M23.75 12a2.643 2.643 0 01-.775 1.875l-9.541 9.541a1.768 1.768 0 01-2.5-2.5l8.739-8.739a.25.25 0 000-.354l-8.739-8.739a1.768 1.768 0 012.5-2.5l9.541 9.541A2.643 2.643 0 0123.75 12z" />
    </g>
  </svg>
));
